module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "drag-handle.8096b9a5.svg";